import * as _ from "lodash";
import * as angular from "angular";
import { DialogUtils } from "../../../helper/dialog.helper";

let AppointmentStatusComponent = {
    selector: "vcAppointmentStatus",
    templateUrl:
        "/angular/components/planner/modals/appointment-status.component.html",
    bindings: {
        status: "=?",
        permission: "=",
        bulk: "=",
    },
    controller: class AppointmentStatusController {
        // * bindings for typescript compiler *
        public status: string;
        public permission: boolean;
        public bulk: boolean;
        // ************************************

        private dialog: DialogUtils;

        public statuses: object;

        constructor(DialogUtils: DialogUtils) {
            this.dialog = DialogUtils;
        }

        $onInit() {
            this.statuses = [
                { id: "Active", value: "To Do" },
                { id: "Done", value: "Completed" },
            ];
            if (!this.bulk) {
                this.statuses = _.concat(
                    [{ id: "", value: "All" }],
                    this.statuses
                );
            }
        }

        confirm(): void {
            this.dialog.hide(this.status);
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("planner")
    .component(AppointmentStatusComponent.selector, AppointmentStatusComponent);
